import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ClubService } from '../shared/services/club.service';

@Injectable({
  providedIn: 'root',
})
export class EventsEnabledGuard implements CanActivate {
  constructor(
    private clubService: ClubService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const showEvents = this.clubService.theme()?.show_events_tab;
    if (!showEvents) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
